export default __webpack_public_path__ + "static/media/sticker-e.ded07ffe.png";